import React from 'react';
import {Breadcrumbs} from '../breadcrumbs/breadcrumbs';
import i18n from './../../utilities/i18n';
import {env_vars} from '../../utilities/load-env';
import {ErrorBox} from '../errorbox/errorbox';

export const InternalServerError = () => {
  return (
    <div className='container'>
      <article className='pagetitle'>
        <Breadcrumbs crumbKey="lisensjeger" title={i18n.t('felles:lisensjeger')}/>
        <h1>{i18n.t('titel:hovedTitel')}</h1>
        <h2>{i18n.t('titel:subTitel')}</h2>
      </article>
      <ErrorBox>
        <h3>{i18n.t('serverError:nettsideIkkeTilgjengelig')}</h3>
        <p>{i18n.t('serverError:provIgjen')}</p>
        <p>
          {i18n.t('serverError:taKontaktPreLink')}
          <a href={env_vars.BRREG_FORSIDE_URL + 'hvordan-kan-vi-hjelpe-deg/'} className='normal-br-link'>
            {i18n.t('serverError:taKontaktLink')}
          </a>
          {i18n.t('serverError:taKontaktPostLink')}
        </p>
        <p>{i18n.t('serverError:huskLogout')}</p>
      </ErrorBox>
      <br className='boxMargin'/>
    </div>);
};
